module.exports = __webpack_public_path__ + "static/media/timesheet.89aba0c6.png";